module.exports = __webpack_public_path__ + "resources/img/main_banner_gov04_m.7e804099d1f7a0d5b6ae6c5188275902.png";